export class QueryBuilder {
  private params: [string, string][] = []

  param = (name: string, value: any): QueryBuilder => {
    if (value === undefined || value === null) return this
    this.params.push([name, value.toString()])
    return this
  }

  build = (): string =>
    this.params
      .map((param) => `${param[0]}=${encodeURIComponent(param[1])}`)
      .join('&')

  toString = () => this.build()
}
